import React, {
  type ComponentType,
  type LazyExoticComponent,
  lazy,
} from "react";
import { useParams } from "react-router-dom";
import type { INavigationComponentProps } from "types/navigation";

type NavComponent = ComponentType<INavigationComponentProps>;

// Menu Management puts an entity's list / create / edit under ONE feature slug
// so the URLs stay clean and bookmarkable:
//   …/menu-management/display-groups              → list
//   …/menu-management/display-groups/create       → create
//   …/menu-management/display-groups/edit/<key>   → edit
// The mode is the :tab segment. This builds the single routable component the
// nav registers for that feature; it renders the matching list / create / edit
// loader wrapper (each of which supplies its own `mode` prop). Returned as a
// LazyExoticComponent to satisfy ISecondaryNavProps.component — the wrappers it
// renders stay their own lazy chunks under MainView's Suspense boundary, so the
// list bundle still isn't shipped until the list is opened, etc.
export function entityModeRoute(
  List: NavComponent,
  Create: NavComponent,
  Edit: NavComponent
): LazyExoticComponent<NavComponent> {
  const EntityModeRoute: NavComponent = () => {
    const { tab } = useParams<{ tab?: string }>();
    if (tab === "create") {
      return <Create />;
    }
    if (tab === "edit") {
      return <Edit />;
    }
    return <List />;
  };
  return lazy(() => Promise.resolve({ default: EntityModeRoute }));
}
